import axios from 'axios'
import { camelizeJson, dasherizeJson } from '@/utils/json'
import Vue from 'vue'
import store from '@/store'
// import moment from 'moment'

let stored = JSON.parse(localStorage.getItem('vuex'))
let url = (stored && stored.authentication && stored.authentication.baseUrl) || 'https://flux.aed.pro'
let token = (stored && stored.authentication && stored.authentication.token) || ''

// function flattenItem (item) {
//   let newItem = {}
//   newItem.type = item.type
//   newItem.id = item.id
//   for (var property in item.attributes) {
//     if (item.attributes.hasOwnProperty(property)) {
//       newItem[property] = item.attributes[property]
//     }
//   }
//   for (var relationship in item.relationships) {
//     if (item.relationships.hasOwnProperty(relationship)) {
//       newItem[relationship] = item.relationships[relationship].data
//     }
//   }
//   return newItem
// }

// function attachRelated (item, included) {
//   for (var relationship in item) {
//     if (item[relationship] && item[relationship].type && item[relationship].id) {
//       included.forEach(includedItem => {
//         if (includedItem && includedItem.type && includedItem.id && includedItem.type === item[relationship].type && includedItem.id === item[relationship].id) {
//           item[relationship] = flattenItem(includedItem)
//         }
//       })
//     }
//   }
//   return item
// }

// function unflattenItem (item) {
//   let newItem = {
//     id: null,
//     type: null,
//     attributes: {},
//     relationships: []
//   }
//   for (var property in item) {
//     if (item[property] && property !== 'attributes' && property !== 'relationships') {
//       if (property === 'type' || property === 'id') {
//         newItem[property] = item[property]
//       } else if (!item[property].type && !item[property].id) {
//         if (moment.isMoment(item[property])) {
//           item[property] = item[property].format('YYYY-MM-DD HH:mm:ss ZZ')
//         }
//         newItem.attributes[property] = item[property]
//       } else {
//         newItem.relationships[property] = {
//           id: item[property].id,
//           type: item[property].type
//         }
//       }
//     }
//   }
//   return newItem
// }

const api = axios.create({
  baseURL: url + '/api/',
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/vnd.api+json',
    'Authorization': 'Bearer ' + token
  }
})

// OUTBOUND INTERCEPTOR
api.interceptors.request.use(function (config) {
  // if (config.data && config.data.data) {
  //   let newData = unflattenItem(config.data.data)
  //   console.log(newData) // TODO - Change this to `config.data.data = newData
  // }
  config.data = JSON.stringify(dasherizeJson(config).data)
  return config
})

// INBOUND INTERCEPTOR
api.interceptors.response.use(function (response) {
  if (response && response.data && response.data.meta) {
    store.commit('updateApiVersion', response.data.meta['api-version'])
    store.commit('updateServerVersion', response.data.meta['api-server-version'])
  }
  store.commit('updateAppVersion', require('../../../package.json').version)
  // response = camelizeJson(response)
  // let newData
  // if (Array.isArray(response.data.data)) {
  //   newData = []
  //   response.data.data.forEach((item) => {
  //     let newEntry = item
  //
  //     if (response.data.included) {
  //       newEntry = attachRelated(flattenItem(item), response.data.included)
  //     } else {
  //       newEntry = flattenItem(item)
  //     }
  //     newData.push(newEntry)
  //   })
  // } else {
  //   if (response.data.included) {
  //     newData = attachRelated(flattenItem(response.data.data), response.data.included)
  //   } else {
  //     newData = flattenItem(response.data.data)
  //   }
  // }
  // TODO -- Add response.data.data = newData

  return camelizeJson(response)
})

Vue.prototype.$api = api

export { api as default }
